import { cn } from '@repo/utils/cn';
import { type ReactNode } from 'react';

type HeaderIconProps = {
  children: ReactNode;
  className?: string;
};

export const HeaderIcon = ({ children, className }: HeaderIconProps) => (
  <div className={cn('vt-site-text vt-containers-game-list-header-comp-text', className)}>{children}</div>
);
